<div class="py-[16px] grid gap-4 laptop:grid-cols-2">
	<div class="activity-container">
		<div class="titleContainer">
			<h2>Responses Leaderboard</h2>
		</div>
		<portals-loading [showIf]="formLoading">
			<div class="infoContainer">
				<div class="table-bar-chart">
					<table class="table">
						<tbody>
							<tr *ngFor="let item of notificationInfoData; let i = index">
								<td class="cta_cell">
									<div class="cta_cell_div">
										<div>{{ item.cta }}</div>
									</div>
								</td>
								<td class="bar_cell">
									<portals-audio-video-bar [data]="getAudioVideoMapData(item)"></portals-audio-video-bar>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="label-container">
					<div class="legendContainer">
						<div class="positiveLabel"></div>
						<span class="label">Video</span>
					</div>
					<div class="legendContainer">
						<div class="neutralLabel"></div>
						<div class="label">Audio</div>
					</div>
					<div class="legendContainer">
						<div class="negativeLabel"></div>
						<div class="label">Text</div>
					</div>
				</div>
			</div>
		</portals-loading>
	</div>
	<div class="activity-container">
		<div class="titleContainer">
			<h2>Average Length of Responses</h2>
		</div>
		<portals-loading [showIf]="formLoading">
			<div class="infoContainer">
				<portals-response-length-bar *ngIf="this.durationData !== null" [data]="convertData(this.durationData)"></portals-response-length-bar>
			</div>
		</portals-loading>
	</div>
</div>
